import styled from '@olxeu-a2b/ui/src/theme/styled';
import { SheetBottom } from '@nexus/lib-react/dist/core/SheetBottom/SheetBottom';
import { Headline3 } from '@nexus/lib-react/dist/core/Typography/Heading';
import ButtonPrimaryDark from '@nexus/lib-react/dist/core/Button/ButtonPrimaryDark';
import ButtonTertiaryDark from '@nexus/lib-react/dist/core/Button/ButtonTertiaryDark';
import { Paragraph4 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import { mq } from '../../styles';

const SheetBottomModal = styled(SheetBottom)`
  ${mq.mobileAndPhabletHorizontal} {
    overflow: auto;
    height: 100vh;
    top: 0;
  }
`;

const Container = styled.div`
  max-width: 312px;
  text-align: center;
  display: grid;
  place-content: center;
`;

const Headline = styled(Headline3)`
  margin-bottom: 16px;
`;

const Description = styled(Paragraph4)`
  color: ${({ theme }) => theme.colors['text-global-secondary']};
`;

const PointsList = styled.ul`
  text-align: left;
  font-size: 14px;
  line-height: 24px;
  margin-top: 24px;
  padding: 0 32px;
  li {
    color: ${({ theme }) => theme.colors['text-global-secondary']};
    padding-left: 10px;
  }
`;

const ConfirmButton = styled(ButtonPrimaryDark)`
  margin: 16px 0 0 0;
  width: 100%;
`;

const ImageContainer = styled.div`
  width: 100%;
  display: grid;
  place-content: center;
  margin-bottom: 16px;
`;

const CloseButtonInBottomSection = styled(ButtonTertiaryDark)`
  margin-top: 20px;
`;

const BottomSection = styled.div`
  text-align: left;
`;

export default {
  SheetBottomModal,
  Container,
  Description,
  PointsList,
  Headline,
  ConfirmButton,
  ImageContainer,
  CloseButtonInBottomSection,
  BottomSection,
};
